import { render } from "./AutocompleteOption.vue?vue&type=template&id=3af0b322&scoped=true&ts=true"
import script from "./AutocompleteOption.vue?vue&type=script&lang=ts"
export * from "./AutocompleteOption.vue?vue&type=script&lang=ts"

import "./autocomplete-input.scss?vue&type=style&index=0&id=3af0b322&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af0b322"]])

export default __exports__